"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var column_measure_dto_1 = require("../dto/column-measure-dto");
var column_category_builder_1 = require("./column-category-builder");
/**
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var ColumnMeasureBuilder = /** @class */ (function () {
    function ColumnMeasureBuilder(measurePathHolderId, currencyId) {
        this.element = new column_measure_dto_1.ColumnMeasureDto();
        this.element.measurePathHolderId = measurePathHolderId;
        this.element.currencyId = typeof currencyId === 'number' ? currencyId : null;
    }
    ColumnMeasureBuilder.prototype.getElement = function () {
        return this.element;
    };
    ColumnMeasureBuilder.prototype.addColumnCategory = function (measurePathHolderId) {
        var child = new column_category_builder_1.ColumnCategoryBuilder(measurePathHolderId);
        this.element.children.push(child.getElement());
        return child;
    };
    ColumnMeasureBuilder.prototype.setUserDefinedAggregationType = function (aggregationType) {
        this.element.userDefinedAggregationType = aggregationType;
        return this;
    };
    ColumnMeasureBuilder.prototype.setOrderType = function (orderType) {
        this.element.orderType = orderType;
        return this;
    };
    ColumnMeasureBuilder.prototype.setShowInPercentage = function (showInPercentage) {
        this.element.isShowInPercentage = showInPercentage;
        return this;
    };
    ColumnMeasureBuilder.prototype.setFilter = function (filter) {
        this.element.filterTreeDto = filter;
        return this;
    };
    ColumnMeasureBuilder.prototype.setCurrencyId = function (currencyId) {
        this.element.currencyId = currencyId;
        return this;
    };
    ColumnMeasureBuilder.prototype.setShowOnRowsTotal = function (showOnRowsTotal) {
        this.element.showOnRowsTotal = showOnRowsTotal;
        return this;
    };
    return ColumnMeasureBuilder;
}());
exports.ColumnMeasureBuilder = ColumnMeasureBuilder;
//# sourceMappingURL=column-measure-builder.js.map